import { useState } from 'react'

type CustomError = { code: string; message: string }

export function useCustomErrors() {
  const [customErrors, setCustomErrors] = useState<CustomError[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  const addError = (error: CustomError) => {
    setLoading(true)

    setTimeout(() => {
      setCustomErrors((prev) => [
        ...prev.filter((e) => e.code !== error.code),
        error,
      ])

      setLoading(false)
    }, 1000)
  }

  const removeError = (code: string) => {
    setCustomErrors((prev) => prev.filter((e) => e.code !== code))
  }

  const clearErrors = () => {
    setCustomErrors([])
  }

  return { customErrors, loading, addError, removeError, clearErrors }
}
